import { sageIllustrations } from "@/assets";
import { cn } from "@/lib/cn";
import { Text } from "./text";

const POSE_ALIASES: Record<string, string> = {
  wave: "wave",
  "thumbs-up": "thumbs",
  thumbs: "thumbs",
  scissors: "scissors",
  polish: "polish",
  stone: "stone",
  cucumber: "stone",
  binoculars: "search",
  search: "search",
  clipboard: "empty",
  empty: "empty",
  shrug: "shrug",
  confetti: "confetti",
  dj: "dj",
};

interface EmptyStateProps {
  pose?: string;
  title: string;
  description?: string;
  action?: React.ReactNode;
  className?: string;
}

function EmptyState({ pose = "wave", title, description, action, className }: EmptyStateProps) {
  const key = POSE_ALIASES[pose] ?? "wave";

  return (
    <div className={cn("flex flex-col items-center text-center p-12 gap-3", className)}>
      <img
        src={sageIllustrations[key]}
        width={120}
        height={120}
        className="object-contain"
        alt={`Sage — ${pose}`}
        draggable={false}
      />
      <Text as="h3" variant="h3">
        {title}
      </Text>
      {description && (
        <Text variant="body" className="text-slate max-w-md">
          {description}
        </Text>
      )}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}

export { EmptyState, type EmptyStateProps };
